import { Component, OnInit, Input, QueryList, Output, EventEmitter, ChangeDetectorRef  } from '@angular/core';

import { PerioTooth, ControlSetup } from '../models/perio.models';
import { PerioToothComponent } from '../perio-tooth/perio-tooth.component';
import { PerioService } from '../services/perio.service';
import { Observable } from 'knockout';
import { Subscription } from 'rxjs';
import {ThemePalette} from "@angular/material/core";

@Component({
  selector: 'app-perio-tooth-details',
  templateUrl: './perio-tooth-details.component.html',
  styleUrls: ['./perio-tooth-details.component.css'],
})
export class PerioToothDetailsComponent implements OnInit {

  @Input() tooth: PerioTooth;
  @Input() facing: string; // buccal or lingual
  @Input() section: string; // upper or lower
  @Input() perioToothComponents: QueryList<PerioToothComponent>;
  @Input() controlSetupList: ControlSetup[];
  @Input() toothIndex: number;

  @Output() onInputEndReached: EventEmitter<string> = new EventEmitter<string>();
  @Output() onInputChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  nextControlKey: string;
  saveSubscriptionOrganizer: any = {};
  tmpChangeObj: number = 0;

  flipInputFields: boolean = false;
  isFocus: boolean = false;

  colorFUR: ThemePalette = 'primary';
  colorMOB: ThemePalette = 'warn';

  checkboxStructureOrganizer: any[] = [

    {
      name: 'BL',
      color: '#8b0000',
      buccalFacingObjs: [
        'FacialBleedingD',
        'FacialBleedingC',
        'FacialBleedingM',
      ],
      lingualFacingObjs: [
        'LingualBleedingD',
        'LingualBleedingC',
        'LingualBleedingM'
      ]
    },
    {
      name: 'SUP',
      color: '#663399',
      buccalFacingObjs: [
        'FacialSuppurationD',
        'FacialSuppurationC',
        'FacialSuppurationM',
      ],
      lingualFacingObjs: [
        'LingualSuppurationD',
        'LingualSuppurationC',
        'LingualSuppurationM'
      ]
    },
    {
      name: 'CLC',
      color: '#2f4f4f',
      buccalFacingObjs: [
        'FacialCalculusD',
        'FacialCalculusC',
        'FacialCalculusM',
      ],
      lingualFacingObjs: [
        'LingualCalculusD',
        'LingualCalculusC',
        'LingualCalculusM'
      ]
    },
    {
      name: 'PLQ',
      color: '#ffA500',
      buccalFacingObjs: [
        'FacialPlaqueD',
        'FacialPlaqueC',
        'FacialPlaqueM',
      ],
      lingualFacingObjs: [
        'LingualPlaqueD',
        'LingualPlaqueC',
        'LingualPlaqueM'
      ]
    },
  ];

  inputStructureOrganizer: any[] = [

    {
      name: 'PD',
      color: '#ff6868',
      buccalFacingObjs: [
        'FacialProbingDepthD',
        'FacialProbingDepthC',
        'FacialProbingDepthM',
      ],
      lingualFacingObjs: [
        'LingualProbingDepthD',
        'LingualProbingDepthC',
        'LingualProbingDepthM'
      ]
    },
    {
      name: 'GM',
      color: '#9090ff',
      buccalFacingObjs: [
        'FacialGingovalMarginD',
        'FacialGingovalMarginC',
        'FacialGingovalMarginM',
      ],
      lingualFacingObjs: [
        'LingualGingovalMarginD',
        'LingualGingovalMarginC',
        'LingualGingovalMarginM'
      ]
    },
    {
      name: 'AL',
      color: '#9ada9a',
      buccalFacingObjs: [
        'FacialClinicalAttachmentLevelD',
        'FacialClinicalAttachmentLevelC',
        'FacialClinicalAttachmentLevelM',
      ],
      lingualFacingObjs: [
        'LingualClinicalAttachmentLevelD',
        'LingualClinicalAttachmentLevelC',
        'LingualClinicalAttachmentLevelM'
      ]
    },


  ];

  constructor(
    private perioService: PerioService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.handleToothChangeForInputFields(this.toothIndex);
  }

  findNextControlKey(currentControlKey: string) {

    let nextControlKeyIndex: number = this.controlSetupList.findIndex(control => {
      return control.controlkey === currentControlKey;
    });

    if (nextControlKeyIndex === -1) {
      nextControlKeyIndex = 0;
    } else if (nextControlKeyIndex === (this.controlSetupList.length - 1)) {
      nextControlKeyIndex = 0;
    } else {
      nextControlKeyIndex++;
    }

    return this.controlSetupList[nextControlKeyIndex];
  }

  shouldEmitEndReached(key: string) {

    var currentToothId = this.parseToothId(this.tooth.ToothId);
    let controlKey = `pt${currentToothId}_${key}`;

    let nextControlSetup = this.findNextControlKey(controlKey);
    this.nextControlKey = nextControlSetup.controlkey;

    let nextControlToothNum: string = nextControlSetup.controlkey.split('pt')[1].split('_')[0];

    if (nextControlToothNum !== currentToothId) {
      return true;
    }

    let containsLingual: boolean = this.nextControlKey.toLowerCase().indexOf('lingual') > -1;

    if (containsLingual && this.facing !== 'lingual') {
      return true;
    } else if (!containsLingual && this.facing !== 'buccal') {
      return true;
    }

    return false;
  }
  addingStyle(key: string, styleColor: string)
  {
    document.getElementById(key).style.backgroundColor = styleColor;
  }
  removingStyle(key: string)
  {
    document.getElementById(key).style.backgroundColor = '#fff';
  }

  onValueChange(value: number, key: string) {

    if (isNaN(value)) {
      value = 0;
      this.tooth[key] = value;
    }

    let emitEndReached: boolean = this.shouldEmitEndReached(key);
    this.saveTooth(this.tooth);

    let toothComponentRef = this.perioToothComponents.find(item => {
      var isItem =
        (item.facing === this.facing) &&
        (item.section === this.section) &&
        (item.tooth.ToothId === this.tooth.ToothId);
      return isItem;
    });

    if (!toothComponentRef) {
      return;
    }

    toothComponentRef.initPerioLines();

    if (emitEndReached && (value === 0 || value)) {
      this.onInputEndReached.emit(this.nextControlKey);
      this.focusOnNextInputElement(this.nextControlKey);
    } else if ((value === 0 || value)) {
      this.focusOnNextInputElement(this.nextControlKey);
    }

  }

  parseToothId(toothId: string) {
    return toothId.substr(toothId.length - 2, toothId.length);
  }

  previousTooth(toothIndex: number){
    var currentToothId = this.parseToothId(this.tooth.ToothId);
    let PreviousToothId = ('0' + (Number(currentToothId) - 1)).slice(-2);
    let key: string;

    if ( this.facing === 'buccal' && this.section ===  'upper')
    {
      if (toothIndex <= 9) {
        key = 'FacialProbingDepthD';
      }
      else{
        key = 'FacialProbingDepthM';
      }
    }
    if ( this.facing === 'buccal' && this.section ===  'lower')
    {
      if (toothIndex === 17)
      {
        PreviousToothId = ('0' + (Number(currentToothId))).slice(-2);
        key = 'LingualProbingDepthM';
      }
      else if (toothIndex <= 25) {
        key = 'FacialProbingDepthM';
      }
      else{
        key = 'FacialProbingDepthD';
      }
    }
    else if (this.facing === 'lingual' && this.section === 'upper'){
      PreviousToothId = ('0' + (Number(currentToothId) + 1 )).slice(-2);
      if (toothIndex === 16)
      {
        PreviousToothId = ('0' + (Number(currentToothId))).slice(-2);
        key = 'FacialProbingDepthM';
      }
      else if (toothIndex >= 8) {
        key = 'LingualProbingDepthM';
      }
      else{
        key = 'LingualProbingDepthD';
      }
    }
    else if (this.facing === 'lingual' && this.section === 'lower'){
      PreviousToothId = ('0' + (Number(currentToothId) + 1 )).slice(-2);
      if (toothIndex === 32) {
        key = 'LingualProbingDepthD';
        PreviousToothId = '01';
      }

      if (toothIndex >= 24) {
        key = 'LingualProbingDepthD';
      }
      else{
        key = 'LingualProbingDepthM';
      }
    }

    let controlKey = `pt${PreviousToothId}_${key}`;

    let nextControlSetup = this.findNextControlKey(controlKey);
    this.nextControlKey = nextControlSetup.controlkey;


    this.onInputEndReached.emit(this.nextControlKey);
  }
  NextTooth(toothIndex: number){
    var currentToothId = this.parseToothId(this.tooth.ToothId);
    var key: string;

    if ( this.facing === 'buccal' && this.section ===  'upper')
    {
      if (toothIndex <= 8) {
      key = 'FacialProbingDepthM';
      }
      else{
        key = 'FacialProbingDepthD';
      }
    }
    if ( this.facing === 'buccal' && this.section ===  'lower')
    {
      if (toothIndex <= 24) {
        key = 'FacialProbingDepthD';
      }
      else{
        key = 'FacialProbingDepthM';
      }
    }
    else if (this.facing === 'lingual' && this.section === 'upper'){
      if (toothIndex >= 9) {
        key = 'LingualProbingDepthD';
      }
      else{
        key = 'LingualProbingDepthM';
      }
    }
    else if (this.facing === 'lingual' && this.section === 'lower'){
      if (toothIndex >= 25) {
        key = 'LingualProbingDepthM';
      }
      else{
        key = 'LingualProbingDepthD';
      }
    }

    let controlKey = `pt${currentToothId}_${key}`;

    let nextControlSetup = this.findNextControlKey(controlKey);
    this.nextControlKey = nextControlSetup.controlkey;


    this.onInputEndReached.emit(this.nextControlKey);
  }

  focusOnNextInputElement(controlKey: string) {
    let inputElementId = controlKey.split('_')[1];

    console.log('FOCUS ON ', inputElementId);

    setTimeout(_ => {
      var element = document.getElementById(inputElementId);

      if (element) {
        document.getElementById(inputElementId).focus();
      }

    }, 100);
  }

  saveTooth(tooth: PerioTooth) {

    let toothClone: PerioTooth = JSON.parse(JSON.stringify(tooth));
    toothClone.cfgTooth = null;

    if (this.saveSubscriptionOrganizer[tooth.PerioChartToothID] && !this.saveSubscriptionOrganizer[tooth.PerioChartToothID].closed) {
      try {
        this.saveSubscriptionOrganizer[tooth.PerioChartToothID].unsubscribe();
      } catch (err) { }
    }

    this.saveSubscriptionOrganizer[tooth.PerioChartToothID] = this.perioService.savePerioTooth(toothClone)
      .subscribe(response => {
      }, err => {
        console.log('ERROR SAVING', err);
      });

  }

  emitValueChange() {
    this.saveTooth(this.tooth);
    this.onInputChanged.emit(true);

    /*const toothComponentRef = this.perioToothComponents.find(item => {
      const isItem =
        (item.facing === this.facing) &&
        (item.section === this.section) &&
        (item.tooth.ToothId === this.tooth.ToothId);
      return isItem;
    });

    if (!toothComponentRef) {
      return;
    }

    toothComponentRef.initIssuesDot();*/



  }

  handleToothChangeForInputFields(toothNumber: number) {

    if ((toothNumber >= 1 && toothNumber <= 8) || (toothNumber <= 32 && toothNumber >= 25)) {

      if (this.flipInputFields !== false) {
        // flip the order of the internal objects

        this.inputStructureOrganizer.forEach(structure => {
          structure.buccalFacingObjs = structure.buccalFacingObjs.reverse();
          structure.lingualFacingObjs = structure.lingualFacingObjs.reverse();
        });

        this.checkboxStructureOrganizer.forEach(structure => {
          structure.buccalFacingObjs = structure.buccalFacingObjs.reverse();
          structure.lingualFacingObjs = structure.lingualFacingObjs.reverse();
        });

        this.flipInputFields = false;
      }

    } else {

      if (this.flipInputFields !== true) {
        // flip the order of the internal objects

        this.inputStructureOrganizer.forEach(structure => {
          structure.buccalFacingObjs = structure.buccalFacingObjs.reverse();
          structure.lingualFacingObjs = structure.lingualFacingObjs.reverse();
        });

        this.checkboxStructureOrganizer.forEach(structure => {
          structure.buccalFacingObjs = structure.buccalFacingObjs.reverse();
          structure.lingualFacingObjs = structure.lingualFacingObjs.reverse();
        });

        this.flipInputFields = true;
      }


    }

  }

}
